import {
  MutationUpdatePatientProfileArgs,
  PatientProfile,
  UpdatePatientProfileMutation,
} from '@app/graphql-types/Source'
import React from 'react'

import UPDATE_PATIENT_PROFILE_MUTATION from '../graphql/patient/UpdatePatientProfileMutation.gql'
import { formatFormDataForServer, FormData } from './useForm'
import { useMutationResult } from './useMutationResult'

interface Props {
  onCompleted?: (data?: PatientProfile | null) => void
}

export const useUpdatePatientProfile = (props?: Props) => {
  const { errors, isSaving, mutate } = useMutationResult<
    UpdatePatientProfileMutation,
    MutationUpdatePatientProfileArgs,
    PatientProfile
  >({
    mutation: UPDATE_PATIENT_PROFILE_MUTATION,
    onCompleted: props?.onCompleted,
    successField: 'updatePatientProfile',
  })
  const updatePatientProfile = React.useCallback(
    async (input: FormData, blob?: Blob) => {
      return mutate({
        input: {
          ...formatFormDataForServer(input),
          profileImage: blob,
        },
      })
    },
    [mutate],
  )
  return React.useMemo(
    () => ({ errors, isSaving, updatePatientProfile }),
    [errors, isSaving, updatePatientProfile],
  )
}
